import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import useStore from "../store/store";

function SwitchControl() {
	let { isAllTime, setIsAllTime } = useStore((state) => state);

	return (
		<FormControlLabel
			style={{ float: "right", margin: 0, padding: 0, marginTop: 5 }}
			control={
				<Switch
					size="small"
					checked={isAllTime}
					onChange={(e) => setIsAllTime(e.target.checked)}
					name="checkBox"
					inputProps={{
						"aria-label": "secondary checkbox",
					}}
				/>
			}
			label={isAllTime ? " Today" : " All-time"}
		/>
	);
}

export default SwitchControl;
